import { Mesh, Object3D, Vector3 } from 'three';
import { EThreejsStub } from '../enums/e_threejs_stub';

if (!Object.prototype.hasOwnProperty.call(Object3D.prototype, 'get_world_position_zero_offset')) {
  Object.defineProperty(Object3D.prototype, 'get_world_position_zero_offset', {
    value: function (): Vector3 {
      const body_position = new Vector3();
      return this.getWorldPosition(body_position);
    },
    writable: false,
    configurable: true,
  });
}

if (!Object.prototype.hasOwnProperty.call(Object3D.prototype, 'is_stub')) {
  Object.defineProperty(Object3D.prototype, 'is_stub', {
    value: function (): boolean {
      return this === EThreejsStub.OBJECT;
    },
    writable: false,
    configurable: true,
  });
}

if (!Object.prototype.hasOwnProperty.call(Object3D.prototype, 'is_mesh_with_name')) {
  Object.defineProperty(Object3D.prototype, 'is_mesh_with_name', {
    value: function (name: string): boolean {
      return this instanceof Mesh && this.name.includes(name);
    },
    writable: false,
    configurable: true,
  });
}

export {};
